<mat-toolbar class="p-0 mat-elevation-z1">
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="navbar-toggle-button" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
      <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>
      <!-- <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/new-dashboard/syndifi-logo-white.svg">
                </div>
            </div> -->
      <div class="px-2 px-md-4 ipad-custom-remove">
        <!-- <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts> -->
      </div>
      <div fxLayoutAlign="flex-start center" style="width: 100%" fxHide fxShow.gt-xs>
        <!-- <div class="logo ml-4 finance-exhange-column-custom">
                    <img class="logo-icon" src="assets/new-dashboard/syndifi-logo-white.svg">
                </div> -->
      </div>
      <div *ngIf="[2].indexOf(this.currentUser['UserDetails'].UserTypeID) === -1" fxLayoutAlign="flex-end center"
        style="width: 100%" fxHide fxShow.gt-xs>
        <div class="px-2 px-md-4 styls">
          <!-- <button style="padding-top: 12px;" (click)="changeDashboard()" mat-button>Old Dashboard</button> -->
          <mat-slide-toggle style="padding-right: 0px !important;padding-top: 12px;font-size: 16px;color: white;"
            (click)="changeDashboard()" [checked]="checkedNewDashboard">New Dashboard</mat-slide-toggle>
        </div>
        <!-- <button mat-button [matMenuTriggerFor]="menu2" class="user-button"
                    *ngIf="currentUser && currentUser.UserDetails.UserTypeID != 5">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <span class="material-icons icodsign"
                            style="font-size: 1em; margin-top: 12px;">date_range</span>
                        <span class="h4 mat-button"
                            style="color:#fff; margin-top: 12px; font-size: 16px;">Reports</span>
                        <mat-icon class="s-16" fxHide.xs style="color: #fff; margin-top: 12px;">keyboard_arrow_down
                        </mat-icon>
                    </div>
                </button> -->
        <!-- <mat-menu #menu2="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item routerLink="/apps/report">
                        <span class="material-icons icodsign">
                            {{ (currentUser == null) ||!currentUser.switchUserprofile &&
                            [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'date_range':
                            ''}}
                        </span>
                        <span class="h4 dtext"> {{ (currentUser == null) ||!currentUser.switchUserprofile &&
                            [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Individual Deal Reports':
                            ''}}
                        </span>
                    </button>
                    <button mat-menu-item routerLink="/apps/deal-pool-report">
                        <span class="material-icons icodsign">
                            {{ (currentUser == null) ||!currentUser.switchUserprofile &&
                            [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'date_range':
                            ''}}
                        </span>
                        <span class="h4 dtext"> {{ (currentUser == null) ||!currentUser.switchUserprofile &&
                            [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Deal Pool Reports':
                            ''}}
                        </span>
                    </button>
                </mat-menu> -->
        <!-- <div class="px-2 px-md-4 styls">
                    <mat-nav-list>
                        <a routerLink="/apps/contacts">
                            <span class="material-icons icodsign">contacts</span>

                            <span class="h4 dtext">{{ (currentUser == null) || !currentUser.switchUserprofile &&
                                [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Buyers' :
                                'Sellers'}}</span>
                        </a>
                    </mat-nav-list>
                </div> -->
        <!-- <div class="px-2 px-md-4 styls">
                    <mat-nav-list>
                        <a routerLink="/apps/chats">
                            <span class="material-icons icodsign">message</span>
                            <span class="h4 dtext">Message</span>
                        </a>
                    </mat-nav-list>
                </div> -->
        <div class="px-2 px-md-4 styls">
        </div>
      </div>
    </div>
    <div class="px-2 px-md-4 ipad-custom-remove">
      <span class="h4">
        <!-- {{unit_name}} -->
      </span>
    </div>
    <div class="px-2 px-md-4 ipad-custom-remove">
    </div>
    <div class="toolbar-mobile-responsive" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

      <div class="notification-wrapper px-2 px-md-4 styls">
        <a matTooltip="NOTIFICATIONS" tooltipClass="tooltip-text" class="notification-btn"
          (click)="markNotificationsRead('general')">
          <span class="material-icons icondsign" matBadgeColor="warn" matBadge="{{unreadNotificationCount}}"
            matBadgeSize="medium" matBadgePosition="above after">notifications_active</span>
        </a>
        <div *ngIf="showNotification" class="notification-content" (clickOutside)="openNotification(false)"
          [exclude]="'.notification-btn'">
          <div class="notification-header">
            <h6> Notifications</h6>
          </div>
          <div class="notification-content-body">
            <mat-list>
              <mat-list-item class="mat-list-hovr" *ngFor="let Notification of unreadNotifications">
                <a [routerLink]="Notification.EventID == 52?'#/apps/chats':'#'"
                  href="{{Notification.EventID == 52?'apps/chats':null}}" class="notification-list"
                  *ngIf="Notification.EventID == 52">
                  <span> {{Notification.EventID == 65?
                    "You have invited a new buyer. Deal invitation has been sent."
                    : Notification.Title}} </span>
                </a>
                <p *ngIf="Notification.EventID != 52" class="notification-list">
                  <span> {{Notification.EventID == 65?
                    "You have invited a new buyer. Deal invitation has been sent."
                    : Notification.Title}} </span>
                </p>
              </mat-list-item>
            </mat-list>
          </div>
        </div>
      </div>

      <div class="update-wrapper px-2 px-md-4 styls">
        <a matTooltip="UPDATES" class="update-btn" (click)="markUpdatesRead()">
          <span class="material-icons icondsign" matBadgeColor="accent" matBadge="{{unreadUpdatesCount}}"
            matBadgeSize="medium" matBadgePosition="above after"><span class="material-symbols-outlined">
              new_releases
            </span></span>
        </a>
        <div *ngIf="showUpdates" class="update-content" (clickOutside)="openUpdates(false)" [exclude]="'.update-btn'">
          <div class="update-header">
            <h6> Updates</h6>
          </div>
          <div class="update-content-body">
            <mat-list>
              <mat-list-item class="mat-list-hovr" *ngFor="let Update of unreadUpdates">
                <a href="{{Update.link}}" class="notification-list" target="_blank">
                  <span> {{Update.Title}} </span>
                </a>
              </mat-list-item>
            </mat-list>
          </div>
        </div>
      </div>

      <button mat-button [matMenuTriggerFor]="menu" class="user-button">
        <div fxLayout="row" fxLayoutAlign="center center">
          <ng-container *ngIf="(currentUser$ | async);else defaultUserAvatar">
            <img class="avatar mr-0 mr-sm-2" src="{{IMAGE_PATH + (currentUser$ | async).UserDetails.ProfilePicture}}"
              alt="User Avatar" *ngIf="(currentUser$ | async).UserDetails.ProfilePicture;else defaultUserAvatar">
          </ng-container>
          <ng-template #defaultUserAvatar>
            <div class="swatch mr-0 mr-sm-2" [ngStyle]="{'background-color':getColor(0)}"
              *ngIf="(currentUser$ | async)">
              {{getInitials((currentUser$ | async).UserDetails.FirstName)}}
            </div>
            <!-- <img mat-card-avatar class="avatar mr-0 mr-sm-2" src="assets/user-no-image.jpeg"
                            alt="User Avatar"> -->
          </ng-template>
          <span class="username mr-12" fxHide fxShow.gt-sm>{{UserName}}</span>
          <span class="h4 mat-button" style="color:#fff; margin-top: 10px;">My Account</span>
          <mat-icon class="s-16" fxHide.xs style="color: #fff; margin-top: 10px;">keyboard_arrow_down
          </mat-icon>
        </div>
      </button>
      <mat-menu #menu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item (click)="openSubDialog()">
          <span class="material-icons">perm_identity</span>
          <span>
            Change Password
          </span>
        </button>
        <button mat-menu-item routerLink="/apps/my-profile">
          <span class="material-icons">account_circle</span>
          <span>
            My Profile
          </span>
        </button>
        <button mat-menu-item routerLink="/apps/company-profile">
          <span class="material-icons">business</span>
          <span>
            Company Profile
          </span>
        </button>
        <button mat-menu-item routerLink="/apps/app-user-vault">
          <span class="material-icons">folder</span>
          <span>
            My Documents
          </span>
        </button>
        <!-- <button *ngIf="(mycheck == true) || (inviteAsso == 5)" mat-menu-item (click)="openAssoDialog()">
                        <span class="material-icons">perm_identity</span>
                        <span>
                            Invite Buyer Associate
                        </span>
                    </button> -->
        <button mat-menu-item *ngIf="subdomain == 'cp'" (click)="backToAdmin()">
          <span class="material-icons">business</span>
          <span>
            Back To Admin
          </span>
        </button>
        <button mat-menu-item (click)="logout()">
          <span class="material-icons">exit_to_app</span>
          <span>
            Logout
          </span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>

<iframe name="iframe_a" width="100%" *ngIf="isshow"></iframe>